import React from 'react'
import Icon from './Icons'
import {LOG_IN_LINK,CREATE_ACCOUNT_LINK,DOWNLOAD,DOWNLOAD_IOS_APP_LINK} from '../externalLinks'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

class HeaderDesktop extends React.Component{

  render() {  
    return(
      <div className='headerDesktop'>
        <div className='headerDesktop-spacerRow'/>
        <div className='headerDesktop-contentRow'>
          <div className='headerDesktop-logo'>
          	<Icon iconName='plickers-logo' />
          </div>

          {!this.props.mobileOS &&
            <a className='headerDesktop-link headerDesktop-link--sign-in' href={LOG_IN_LINK} >
              Sign in
            </a>
          }

          {!this.props.mobileOS &&

            <OutboundLink className='headerDesktop-link headerDesktop-link--get-started' href={CREATE_ACCOUNT_LINK} >
              Get Started
              <Icon iconName='chevron-right' />
            </OutboundLink>
          }

          {this.props.mobileOS === 'iPad' &&

            <a className='headerDesktop-link headerDesktop-link--get-started' href={DOWNLOAD_IOS_APP_LINK} >
              Get Started
              <Icon iconName='chevron-right' />
            </a>
          }


        </div>    
      </div>    
    )
  } 
}

export default HeaderDesktop
